import { shieldCheck } from "@simplybusiness/icons";
import { Container, Icon, Text, Trust } from "@simplybusiness/mobius";

export const SpecialistReferralContentTrustSection = () => (
  <div className="mobius-specialist-referral-content-page__trust-section">
    <Container size="sm">
      <div className="mobius-specialist-referral-content-page__trust-content">
        <Trust locale="en-GB" theme="dark" variant="micro-combo" stars="4,5" />
        <div className="mobius-specialist-referral-content-page__strapline">
          <Icon
            icon={shieldCheck}
            size="md"
            className="mobius-specialist-referral-content-page__strapline-icon"
          />
          <Text
            variant="body"
            className="mobius-specialist-referral-content-page__strapline-text"
          >
            Insuring over 1 million small businesses worldwide.
          </Text>
        </div>
      </div>
    </Container>
  </div>
);
